import React from "react";
import * as C from "./styles";

type Props = {
  title: string;
  containerStyle?: React.CSSProperties;
};

export default function SectionTitle({ title, containerStyle }: Props) {
  let arrTitle = title.split("~");
  
  return (
    <C.MainContainer style={containerStyle}>
      <C.Title>
        <C.LightTitle>{arrTitle[0]} </C.LightTitle>
        {arrTitle[1]}
      </C.Title>
      <C.BottomBar />
    </C.MainContainer>
  );
}
